import { CrewList, CrewListMember } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class CrewListParser {
    static toGateway(crewList, app) {
        return {
            Id: crewList._id,
            CreatedTimestamp: crewList.createdTimestamp,
            Author: getAuthorRefForGateway(crewList.author, app),
            CrewMembers: crewList.crewMembers.map((crewMember) => ({
                Rank: crewMember.rank,
                Name: crewMember.name,
                Nationality: crewMember.nationality,
                DateOfBirth: crewMember.dateOfBirth,
                PlaceOfBirth: crewMember.placeOfBirth,
                PassportId: crewMember.passportId,
                employmentContract: crewMember.employmentContract,
                seamansRecordBook: crewMember.seamansRecordBook,
                qualificationsAccToSTCW: crewMember.qualificationsAccToSTCW,
                visa: crewMember.visa,
            })),
            StartTimestamp: crewList.startTimestamp,
            EndTimestamp: crewList.endTimestamp,
            Predecessor: crewList.predecessor,
        };
    }
    static fromGateway(gatewayCrewList, app) {
        const crewList = new CrewList({ author: getAuthorRefFromGateway(gatewayCrewList.Author, app) });
        crewList.crewMembers = gatewayCrewList.CrewMembers.map((gatewayCrewMember) => {
            const crewMember = new CrewListMember({
                rank: gatewayCrewMember.Rank,
                name: gatewayCrewMember.Name,
                nationality: gatewayCrewMember.Nationality,
                dateOfBirth: gatewayCrewMember.DateOfBirth,
                placeOfBirth: gatewayCrewMember.PlaceOfBirth,
                passportId: gatewayCrewMember.PassportId,
                qualificationsAccToSTCW: gatewayCrewMember.qualificationsAccToSTCW,
                seamansRecordBook: gatewayCrewMember.seamansRecordBook,
                employmentContract: gatewayCrewMember.employmentContract,
                visa: gatewayCrewMember.visa,
            });
            return crewMember;
        });
        crewList.startTimestamp = gatewayCrewList.StartTimestamp;
        if (gatewayCrewList.EndTimestamp) {
            crewList.endTimestamp = gatewayCrewList.EndTimestamp;
        }
        if (gatewayCrewList.Predecessor) {
            crewList.predecessor = CrewList.createRef(gatewayCrewList.Predecessor._id);
        }
        Object.assign(crewList, {
            _id: gatewayCrewList.Id,
            createdTimestamp: gatewayCrewList.CreatedTimestamp,
        });
        return crewList;
    }
}
//# sourceMappingURL=CrewListParser.js.map